import { render, staticRenderFns } from "./Frame15.vue?vue&type=template&id=533e893a&scoped=true"
import script from "./Frame15.vue?vue&type=script&lang=js"
export * from "./Frame15.vue?vue&type=script&lang=js"
import style0 from "./Frame15.vue?vue&type=style&index=0&id=533e893a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e893a",
  null
  
)

export default component.exports